<script>
  import { globalComputed } from "@store/helpers";
  export default {
    components: {
    },
    data() {
      return {
        menuList: [
          {
            text: '關於',
            to: {
              name: 'about-list'
            }
          },
          {
            text: '新訊',
            type: 'nav',
            to: {
              name: 'news-list'
            },
          },
          {
            text: '解決方案',
            to: {
              name: 'solution-list'
            }
          },
          {
            text: '微軟原⽣解決⽅案',
            to: {
              name: 'resource-list'
            }
          },
        ],
        infoList: [
          {
            title: '地址',
            text: '台北市內湖路一段360巷8號10樓',
            path: 'https://www.google.com.tw/maps/search/台北市內湖路一段360巷8號10樓'
          },
          {
            title: '電話',
            text: '(02)2656-5656',
            path: 'tel:02-2656-5656',
          },
          {
            title: '傳真',
            text: '(02)2656-0810',
            path: 'tel:02-2656-0810',
          }
        ]
      }
    },
    computed: {
      ...globalComputed,
      toolList() {
        return [
          {
            text: '聯絡我們',
            path: this.$globalContactLink
          },
          {
            text: '會員登入',
            path: `/login`
          },
        ]
      },
      foramtLineId() {
        return (this.currentSetting.lineId || '').replace('@', '')
      },
      socialList(){
        return [
          {
            text: 'facebook',
            icon: '<i class="icomoon icon-fb facebook"></i>',
            path: this.currentSetting?.fbFanpageUrl ?? ''
          },
          {
            text: 'line',
            icon: '<i class="fab fa-line line"></i>',
            path:  this.currentSetting?.lineId ? `https://line.me/R/ti/p/%40${this.foramtLineId}`: ''
          },
          {
            text: 'youtube',
            icon: '<i class="fab fa-youtube youtube"></i>',
            path: this.currentSetting.youtubeUrl ?? ''
          }
        ]
      }
    }
  }
</script>
<template>
  <footer :class="$style.footer">
    <div class="footer__inner">
      <div class="container--medium">
        <div class="d-xl-none">
          <div class="d-flex justify-content-md-center text-center mb-2">
            <img 
                src="@assets/images/footer/zerone@2.png" 
                alt="ZeroneLogo"
                class="footer__logo"
            >
            <img 
              src="@assets/images/footer/microsoft@2.png" 
              alt="MicrosoftLogo"
              class="footer__logo"
            >
          </div>
          <div class="footer__footerBottomList center d-md-none">
            <ul :class="$style.navList" class="infoList">
              <li class="navList__infoItem">
                零壹科技股份有限公司
              </li>
              <template v-for="(infoItem, index) in infoList">
                <li
                  :key="index"
                  class="navList__infoItem"
                >
                  {{ infoItem.title }}:
                  <a
                    class="navList__link d-inline"
                    target="_blank"
                    :href="infoItem.path"
                  >
                    {{ infoItem.text }}
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </div>
        
        <div class="footer__footerTop">
          <div class="footer__footerTopList left d-xl-block d-none">
            <img 
                src="@assets/images/footer/zerone@2.png" 
                alt="ZeroneLogo"
                class="footer__logo"
            >
            <img 
              src="@assets/images/footer/microsoft@2.png" 
              alt="MicrosoftLogo"
              class="footer__logo MicrosoftLogo"
            >
          </div>
          <div class="footer__footerTopList center">
            <ul :class="$style.navList">
              <template v-for="(menuItem, index) in menuList">
                <li
                  :key="index"
                  class="navList__item"
                >
                  <router-link
                    class="navList__link font-medium"
                    :to="menuItem.to"
                  >
                    {{ menuItem.text }}
                  </router-link>
                </li>
              </template>
            </ul>
          </div>
          <div class="footer__footerTopList right">
            <ul :class="$style.navList">
              <template v-for="(toolItem, index) in toolList">
                <li
                  :key="index"
                  class="navList__item"
                >
                  <a
                    class="navList__link font-medium"
                    :href="toolItem.path"
                  >
                    {{ toolItem.text }}
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <el-divider class="color-white my-4 d-md-block d-none"></el-divider> 
        <div class="footer__footerBottom">
          <div class="footer__footerBottomList left">
            <ul :class="$style.navList">
              <template v-for="(socialItem, index) in socialList">
                <li
                  v-if="socialItem.path"
                  :key="index"
                  class="navList__socialItem"
                >
                  <a
                    :href="socialItem.path"
                    target="_blank"
                    class="navList__link"
                  >
                    <span v-html="socialItem.icon"></span>
                    <span class="sr-only">{{socialItem.text}}</span>
                  </a>
                </li>
              </template>
            </ul>
          </div>
          <div class="footer__footerBottomList center d-md-block d-none">
            <ul :class="$style.navList" class="infoList">
              <li class="navList__infoItem">
                零壹科技股份有限公司
              </li>
              <template v-for="(infoItem, index) in infoList">
                <li
                  :key="index"
                  class="navList__infoItem"
                >
                  {{ infoItem.title }}:
                  <a
                    class="navList__link d-inline"
                    target="_blank"
                    :href="infoItem.path"
                  >
                    {{ infoItem.text }}
                  </a>
                </li>
              </template>
            </ul>
          </div>
          <div class="footer__footerBottomList right d-xl-block d-none">
            <div class="font-light">© 零壹科技股份有限公司 2022, All Rights Reserved</div>
            <div class="mt-3" style="letter-spacing: 0;">Design by Daydream Lab</div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="d-xl-none color-white text-center md:text-lg text-sm">
        <div class="font-light pb-1">© 零壹科技股份有限公司 2022, All Rights Reserved</div>
        <div class="pb-3" style="letter-spacing: 0;">Design by Daydream Lab</div>
    </div>
  </footer>
</template>
<style lang="scss" module>
  .footer {
    background: transparent linear-gradient(256deg, rgba(171, 205, 3, 1) 0%, rgba(0, 120, 212, 1) 100%) 0% 0% no-repeat padding-box;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      background-image: url('@assets/images/footer/footer_decoration_left.svg');
      background-size: cover;
      padding-bottom: 15%;
      width: 35%;
      @include max-md {
        padding-bottom: 31%;
        width: 71%;
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      background-image: url('@assets/images/footer/footer_decoration_right.svg');
      background-size: cover;
      padding-bottom: 27%;
      width: 57%;
      @include max-md {
        padding-bottom: 35%;
        width: 70%;
      }
    }
    :global {
      .footer {
        &__inner {
          padding-top: 6.4rem;
          padding-bottom: 6.4rem;
          position: relative;
          z-index: 1;
          @include max-md {
            padding-top: 3.4rem;
            padding-bottom: 1.4rem;
          }
        }
        &__footerTop {
          display: flex;
          @include max-xl {
            justify-content: center;
          }
          @include max-md {
            display: block;
          }
          // justify-content: space-around;
        }
        &__footerTopList {
          &.left {
            padding-right: 1rem;
          }
          &.center {

          }
          &:not(:first-child) {
            border-left: 1px solid #fff;
            padding-right: 1.45rem;
            padding-left: 1.45rem;
            @media screen and (max-width: 1439px) {
              padding-right: 0.8rem;
              padding-left: 0.8rem;
            }
            @include max-xl {
              border-left: 0;
              padding-right: 0;
              padding-left: 0;
            }
          }
        }
        &__footerBottomList {
          padding-top: 0.8rem;
          padding-bottom: 0.8rem;
          align-self: center;
          &.left {
            padding-right: 6.2rem;
            padding-left: 2.2rem;
            @media screen and (max-width: 1439px) {
              padding-right: 4.4rem;
            }
            @include max-xl {
              padding-right: 2.5rem;
            }
            @include max-md {
              padding-left: 0;
              padding-right: 0;
              margin-top: 1rem;
              border-top: 1px solid #fff;
              padding-top: 2rem;
            }
          }
          &:not(:first-child) {
            border-left: 1px solid #fff;
            padding-right: 1.45rem;
            padding-left: 3.35rem;
            @media screen and (max-width: 1439px) {
              padding-right: 0;
              padding-left: 0;
            }
            @include max-md {
              border-left: 0;
            }
          }
          &.center {
            padding-right: 3.35rem;
            @media screen and (max-width: 1439px) {
              padding-right: 1.55rem;
              padding-left: 2.55rem;
            }
            @include max-md {
              padding-left: 0;
              padding-right: 0;
            }
          }
          &.right {
            padding-right: 0;
            padding-top: 2rem;
            padding-bottom: 2rem;
            color: #fff;
            letter-spacing: 0.1em;
            @media screen and (max-width: 1439px) {
              // padding-right: 2.25rem;
              padding-left: 2.25rem
            }
            @include max-md {
              padding-left: 0;
              padding-right: 0;
            }
          }
        }
        &__footerBottom {
          display: flex;
          @include max-xl {
            justify-content: center;
          }
          @include max-md {
            display: block;
          }
        }
        &__logo {
          height: 35px;
          margin-right: 3rem;
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
          &.MicrosoftLogo {
            height: 45px;
          }
          @media screen and (max-width: 1439px) {
            margin-right: 1.55rem;
          }
          @include max-xl {
            margin-right: 0;
            &:not(:first-child) {
              margin-left: 1.55rem;
            }
          }
          @include max-sm {
            height: auto;
            max-width: 110px;
            max-height: 35px;
          }
        }
      }
    }
  }
  .navList {
    @include list-unstyled;
    display: flex;
    @include max-md {
      flex-wrap: wrap;
      justify-content: space-between;
    }
    :global {
      .navList {
        &__item {
          display: flex;
          @include max-md {
            width: 50%;
          }
        }
        &__link {
          color: #fff;
          display: inline-block;
          // height: 42px;
          padding: 0.9rem 1.8rem;
          font-size: 1.125rem;
          &.router-link-active {
            text-decoration: underline;
          }
          @media screen and(max-width: 1439px) {
            padding: 0.9rem 1rem;
          }
          @include max-md {
            width: 100%;
            font-size: 0.875rem;
            padding: 0.5rem 0;
          }
          .line, .youtube {
            font-size: 1.8rem;
            @include max-md {
              font-size: 1.25rem;
            }
          }
          &:hover {
            text-decoration: underline;
          };
          
        }
        &__socialItem {
          &:not(:last-child) {
            margin-right: 40px;
            @media screen and(max-width: 1439px) {
              margin-right: 30px;
            }
          }
          .navList__link {
            width: 75px;
            height: 75px;
            font-size: 24px;
            line-height: 75px;
            color: #fff;
            text-align: center;
            letter-spacing: 0;
            border: 1px solid #fff;
            border-radius: 50%;
            transition: .3s;
            padding: 0;
            &:hover {
              color: $color-primary;
              background-color:#fff;
              text-decoration: none;
            }
            @include max-md {
              width: 50px;
              height: 50px;
              font-size: 1.125rem;
              line-height: 50px;
            }
          }
          
        }
        &__infoItem {
          font-size: 1.125rem;
          color: #fff;
          @include max-md {
            font-size: 0.875rem;
          }
        } 
      }
    }
    &:global {
      &.infoList {
        flex-direction: column;
        .navList__link {
          padding: 0;
        }
      }
    }
  }
</style>
